import ComplianceDocumentFormPreview from 'domain/compliance/complianceRegistry/shared/ComplianceDocumentFormPreview';
import React, { useMemo } from 'react';
import ViewComplianceDocumentModalActions from './ViewComplianceDocumentModalActions';
import { useFormContext } from 'framework/form';
import { ComplianceDocumentFormType } from 'domain/shared/compliance';

const ViewComplianceDocumentContent = ({ closeModal }: { closeModal?: () => void }) => {
  const { data: formData } = useFormContext();
  const { paths } = formData || {};
  const documentPath = useMemo(() => (paths?.length ? paths[0] : ''), [paths]);

  return (
    <>
      <ComplianceDocumentFormPreview documentPath={documentPath} formData={formData as ComplianceDocumentFormType} />

      <ViewComplianceDocumentModalActions onCloseModal={closeModal!} />
    </>
  );
};

export default ViewComplianceDocumentContent;
